import React from 'react'
import LinkWrap from 'components/LinkWrap'

const PageLink = ({
  pageLink,
  className,
  partiallyActive = true,
  children,
}) => {
  if (pageLink) {
    const { categories, link, slug, nodeType, template } = pageLink
    let setLink
    // if page, just use the link
    if (nodeType === 'Page') {
      setLink = link === '/home/' ? '/' : link
    }
    // if post, use template directory + slug
    if (nodeType === 'Post') {
      const firstCategory = categories.nodes[0]
      setLink = `/${firstCategory.slug}/${slug}/`
    }
    return (
      <LinkWrap
        to={setLink}
        className={className}
        partiallyActive={partiallyActive}
      >
        {children}
      </LinkWrap>
    )
  } else {
    return <div className={className}>{children}</div>
  }
}

export default PageLink
